exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bold-text3[data-v-4bb18242]{font-size:20px}.bold-text3[data-v-4bb18242],.bold-text4[data-v-4bb18242]{font-family:Karla;font-style:normal;font-weight:700;text-align:center;letter-spacing:-.02em;color:#303941}.bold-text4[data-v-4bb18242]{font-size:28px}.bold-text2[data-v-4bb18242]{font-family:Karla;font-style:normal;font-weight:700;font-size:16px;line-height:19px;text-align:center;color:#667085}.color-text[data-v-4bb18242]{color:#19d3da!important}", ""]);

// exports
